module.exports = __webpack_public_path__ + "static/media/cleric_wand.dd317bb5.png";